import React from "react";
import { Mui } from "@osu/react-ui";
import DemographicItem from "./demographicItem"; // Import the new component
import useRoleAuthentication from "../../Authentication/hooks/useRoleAuthentication";
import { useSelector } from "react-redux";
import { selectDemographicData } from "../../services/graphql/slices/applicant-detail-slices/demographics-slice"; // Import the new slice
import { SCHOLARS_PRIORITY } from "../../util/constants"; // Priority tier KEY -> label map

const Demographics = () => {
  const authDetails = useRoleAuthentication();
  const demographicData = useSelector(selectDemographicData); // Call the new slice

  const {
    earlyAction,
    termLabel,
    admitType,
    academicPlan,
    academicPlanDescription,
    academicProgram,
    academicProgramDescription,
    regularDecision,
    lowSocioeconomic,
    firstGen,
    countryOfCitizenship,
    homeCountry,
    residency,
    priority,
  } = demographicData || {};

  const isAuthorized = authDetails.isAnyAdmin || authDetails.isHonorsSeasonalManager || authDetails.isHonorsProgramCoordinator;

  // Scholars applicant priority tier (FIRST_CHOICE | HONORS_DENIED). Map the raw KEY to a label;
  // fall back to the raw value if an unknown KEY appears. Null/empty for non-Scholars applications.
  const priorityLabel = priority ? (SCHOLARS_PRIORITY[priority]?.LABEL ?? priority) : null;

  return (
    <>
      <Mui.Grid container spacing={2}>
        <Mui.Grid item xs={4}>
          <Mui.List>
            {isAuthorized && ( <DemographicItem label="Early Action" value={earlyAction} /> )}
            <DemographicItem label="Admit Term" value={termLabel} />
            <DemographicItem label="Admit Type" value={admitType} />
            {priorityLabel && ( <DemographicItem label="Priority" value={priorityLabel} /> )}
           </Mui.List>
        </Mui.Grid>

        <Mui.Grid item xs={4}>
          <Mui.List>
            {isAuthorized && ( <DemographicItem label="Regular Decision" value={regularDecision} /> )}
            <DemographicItem label="Low Socio-Economic" value={lowSocioeconomic} />
            <DemographicItem label="First Gen" value={firstGen} />
            <DemographicItem label="Academic Program" value={academicProgram} tooltip={academicProgramDescription} />
         </Mui.List>
        </Mui.Grid>

        <Mui.Grid item xs={4}>
          <Mui.List>
            <DemographicItem label="Country of Citizenship" value={countryOfCitizenship} />
            <DemographicItem label="Country of Home Address" value={homeCountry} />
            <DemographicItem label="Residency" value={residency} />
            <DemographicItem label="Academic Plan" value={academicPlan} tooltip={academicPlanDescription} />
          </Mui.List>
        </Mui.Grid>
      </Mui.Grid>
    </>
  );
};

export default Demographics;